var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.subClassTab.length)?_c('div',{staticClass:"class-tab-wrapper"},[_c('div',{staticClass:"class-tab-scroll"},_vm._l((_vm.subClassTab),function(item,index){return _c('div',{key:index,class:[
        'tab',
        {
          active: index === _vm.activeIndex
        }
      ],on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }